import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Button, ButtonWrapper } from '../../../../../components/UI/Button'
import { TabModel } from '../../../../../models'
import { useHoteleria } from '../../../../../hooks/useHoteleria'
import { useCentral } from '../../../../../hooks/useCentral'
import { TabCentralModel } from '../../../../../models'
interface Props {
  loading?: boolean
  updateClick?: (pre?: boolean | false) => void
  filterClick?: () => void
  deleteClick?: () => void
  textComponentGo?: string
  textComponentBack?: string
  seleccionados?: number
}
const ActionsCheckinContent = ({
  loading,
  updateClick,
  filterClick,
  deleteClick,
  textComponentGo = '',
  textComponentBack = '',
  seleccionados = 0
}: Props) => {
  const { currentTabItem, changeCurrentTabItem, isAllowed } = useHoteleria()
  const { currentTabItem: currentTabItemCentral, changeCurrentTabItem: changeCurrentTabItemCentral } =
    useCentral()
  const { reset } = useFormContext()
  const handleShowNewForm = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      content: {
        headerPanel: textComponentGo,
      },
    }
    changeCurrentTabItem(obj)
    reset()
  }
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      content: {
        headerPanel: textComponentBack,
      },
    }
    reset()
    changeCurrentTabItem(obj)
  }
  const handleRestText = () => {
    reset()
    const obj: TabCentralModel = {
      ...currentTabItemCentral,
      reset: true,
    }
    changeCurrentTabItemCentral(obj)
  }
  let getDisabledDelete = currentTabItem.idToDelete ? false : true
  // console.log({currentTabItem}, {textComponentGo})
  return (
    <ButtonWrapper>
      {textComponentBack === 'table-checkin' || textComponentBack === 'table-checkout' ? (
        <>
          {currentTabItem.content.headerPanel === textComponentBack &&
            isAllowed('BUSCAR_HUESPED') && <Button label='Buscar Huésped' onClick={filterClick} />}

          {textComponentBack === 'table-checkin'
            ? isAllowed('CHECKIN') && (<>
              <Button label='Check in' disabled={seleccionados === 0} onClick={() => updateClick(false)} />
              <Button label='Pre-Checkin' disabled={seleccionados === 0} onClick={() => updateClick(true)} />
            </>)
            : isAllowed('CHECKOUT') && (
              <Button label='Check out' disabled={getDisabledDelete} onClick={updateClick} />
            )}

          {currentTabItem.content.headerPanel === textComponentGo && (
            <Button label='Volver al listado' classNameProp='ms-auto' onClick={handleBack} />
          )}
        </>
      ) : (
        <>
          {currentTabItem.content.headerPanel === textComponentBack && isAllowed('NUEVO') && (
            <Button label='Nuevo' onClick={handleShowNewForm} />
          )}
          {(currentTabItem.content.headerPanel === textComponentGo || currentTabItem.showPanel) &&
            !currentTabItem.noFormDetail && (
              <Button typeBtn='submit' label='Guardar' loading={loading} disabled={loading} />
            )}
          {currentTabItem.content.headerPanel === textComponentGo && (
            <Button label='Limpiar' onClick={handleRestText} />
          )}
          {isAllowed('ELIMINAR') && (
            <Button label='Eliminar' disabled={getDisabledDelete} onClick={deleteClick} />
          )}
          {currentTabItem.content.headerPanel === textComponentGo && (
            <Button label='Volver al listado' classNameProp='ms-auto' onClick={handleBack} />
          )}
        </>
      )}
    </ButtonWrapper>
  )
}

export default ActionsCheckinContent
